import { countries } from "../constatnts/countries"

export const getCountryId = (country: string) => {
    const countryObj = countries.find(con => con.name.toLocaleLowerCase() === country.toLocaleLowerCase())
    return countryObj?.id || ''
}